import {
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
} from "reactstrap";
import { useEffect, useState } from "react";
import axios from "axios";

const VehiculoResultados = (props) => {
  const [vehicleInfo, setVehicleInfo] = useState({
    v: {
      id: "",
      placa: "",
      modelo: "",
      tipoVehiculo: "",
      propietarioId: "",
      vin: "",
      idMarca: "",
    },
    marca: "",
  });

  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url:
        "https://inspecciongnvback-dev.azurewebsites.net/api/v1/ObtenerVehiculos/" +
        props.vehiculoId,
    })
      .then((response) => {
        setVehicleInfo(response.data[0]); // Asumiendo que solo hay un vehículo en la respuesta
        console.log(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [props.vehiculoId]);

  return (
    <>
      {/* Page content */}

      <br></br>
      <Container className="mt--1" fluid>
        <br></br>
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0">
                <h3 className="mb-0">Información del Vehículo</h3>
              </CardHeader>
              <CardBody>
                <Form>
                  <Row>
                    <Col lg="6">
                      <FormGroup>
                        <label>
                          <h1>Placa</h1>
                        </label>
                        <Input
                          type="text"
                          value={vehicleInfo.v?.placa || ""}
                          readOnly
                        />
                      </FormGroup>
                    </Col>
                    <Col lg="6">
                      <FormGroup>
                        <label>
                          <h1>VIN</h1>
                        </label>
                        <Input
                          type="text"
                          value={vehicleInfo.v?.vin || ""}
                          readOnly
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="6">
                      <FormGroup>
                        <label>
                          <h1>Modelo</h1>
                        </label>
                        <Input
                          type="text"
                          value={vehicleInfo.v?.modelo || ""}
                          readOnly
                        />
                      </FormGroup>
                    </Col>
                    <Col lg="6">
                      <FormGroup>
                        <label>
                          <h1>Tipo de Vehículo</h1>
                        </label>
                        <Input
                          type="text"
                          value={vehicleInfo.v?.tipoVehiculo || ""}
                          readOnly
                        />
                      </FormGroup>
                    </Col>
                    <Col lg="6">
                      <FormGroup>
                        <label>
                          <h1>Marca</h1>
                        </label>
                        <Input
                          type="text"
                          value={vehicleInfo.marca || ""}
                          readOnly
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                </Form>
              </CardBody>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default VehiculoResultados;
